export default "__VITE_ASSET__Cwh9ZMSo__"